import React from 'react'
import TribologySamplesRecipt from '../../../../components/Tribology/Samples/Recipt'

const PageTribologySamplesRecipt = () => {
  return <TribologySamplesRecipt />
}

export default PageTribologySamplesRecipt
